<template>
    <v-container class="pb-2" :class="{ 'px-0': wide }">
        <v-card
            class="soli-round py-5"
            :class="{
                'px-4': $vuetify.breakpoint.smAndUp,
                'px-2': $vuetify.breakpoint.xs,
            }"
            outlined
            flat
        >
            <SoliAvatarBtn
                v-if="lesson"
                :title="`${lesson.instrument.name} Assessment w/ ${lesson.teacher.name}`"
                :avatar="lesson.teacher.profile_photo_url"
                :subtitleTop="`${globalMomentLocalLongDate(
                    lesson.starts_at
                )} at ${globalMomentTime(lesson.starts_at)}`"
                :subtitleBottom="`${lesson.duration} min | ${
                    guest.virtual_client ? '' : lesson.location.name + ' |'
                } ${lesson.online ? 'Online' : 'In-Person'}`"
                blueShadow
                disabled
                class="justify-start"
                :size="size"
                :ripple="false"
                ><template>
                    <Link
                        v-if="!hideMakeAChange"
                        :href="
                            route('getStarted.bookNow', this.child?.hash_id, {})
                        "
                        class="flex"
                        :class="
                            $vuetify.breakpoint.width >= 375
                                ? 'justify-start'
                                : 'justify-center'
                        "
                        style="text-transform: none"
                        >Need to make a change?</Link
                    ></template
                >
            </SoliAvatarBtn>
        </v-card></v-container
    >
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";
import { Link } from "@inertiajs/vue2";

export default {
    mixins: [globalMoment],
    components: {
        Link,
    },
    props: {
        lesson: {
            type: Object,
            default: null,
        },
        guest: {
            type: Object,
            default: () => {},
        },
        child: {
            type: Object,
            default: () => {},
        },
        hideMakeAChange: {
            type: Boolean,
            default: false,
        },
        size: {
            type: [String, Number],
            default: 96,
        },
        wide: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        lessonTitle() {
            if (this.event) return this.event.title;
            if (this.assessmentType?.apl) return "Piano Lab";
            if (this.instrument) {
                return `${this.instrument.name} ${this.type.name}`;
            }
        },
    },
};
</script>
